module.exports = __webpack_public_path__ + "img/news3-10.4dac16a1.jpeg";